import React, { useState } from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { toast } from "react-toastify";

const CopyButton = ({ text, style = {}, className = "" }) => {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (e) {
      toast.error("Failed to copy text");
    }
  };

  if (!text) return null;

  return (
    <OverlayTrigger
      placement="top"
      overlay={
        copied ? (
          <Tooltip id="tooltip-copied">Copied!</Tooltip>
        ) : (
          <Tooltip id="tooltip-copy">Copy to clipboard</Tooltip>
        )
      }
    >
      <Button
        variant="outline-secondary"
        size="sm"
        className={`m-0 ${className}`}
        onClick={copyToClipboard}
        style={{ ...style }}
      >
        {copied ? <i className="fa fa-check" /> : <i className="fa fa-copy" />}
      </Button>
    </OverlayTrigger>
  );
};

export default CopyButton;
